import React from 'react';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';
import styles from '../common/statusSummary.styles';
import { HealthStatusCount } from '../common/healthStatusCount';

export const ReferencePoints = props => {
  const { summary } = props;
  return (
    <a
      className={css(styles.cards, styles.cardRp)}
      onClick={() => props.rowDisplay('showRps')}
      href="#/?RP=true "
      style={{
        boxShadow:
          summary.borderColor && summary.borderColor.boxShadow,
        border:
          summary.borderColor && summary.borderColor.border,
        background: props.activeBackground
      }}
    >
      <div className={css(styles.fieldHeader)}>
        <div className={css(styles.title)}>
          {I18n.t('referencePointTableHeader.title')}
        </div>
        <span className={css(styles.totalCount)}>
          {summary.totalCount}
        </span>
      </div>
      <HealthStatusCount
        counts={
          summary.healthStatusCount
        }
      />
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/components/data/status/referencepoint/index.js